<template>
  <div class="mb-5 last:mb-0 md:max-w-xxs md:mx-auto">
    <label v-if="label" class="text-base mb-2 flex w-auto items-start">
      {{ label }}
      <span v-if="isRequired" class="text-velux-red ml-0.5">*</span></label
    >
    <select
      @blur="handleValidation({ isBlur: true })"
      @change="
        handleValidation();
        handleInput($event);
      "
      v-model="model.select"
      :name="name"
      :id="id"
      class="
        px-4
        w-full
        py-3.5
        md:p-3
        text-base
        md:text-lg
        border
        placeholder-velux-grey-300
        font-bold
      "
      :class="{
        'border-velux-red': hasError()
      }"
    >
      <option value="" :selected="placeholder" v-if="placeholder">
        {{ placeholder }}
      </option>
      
      <option v-for="(option, index) in options()" :key="index" :value="option.key">
        {{ option.value }}
      </option>
    </select>
    <div
      v-if="hasError() && errorMessage"
      class="text-velux-red mt-1 font-bold text-left text-base"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";
const hasValidValue = value => (value ? value !== "" && value > 0 : true);

export default {
  setup: () => ({ $v: useVuelidate() }),
  props: {
    id: {
      type: String
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    options: {
      type: Function,
      default: function() {
        return [{
          key: 9,
          value: "9 AM"          
        },
        {
          key: 11,
          value: "11 AM"          
        },
        {
          key: 13,
          value: "13 PM"          
        },
        {
          key: 15,
          value: "15 PM"          
        }]
      }
    },
    errorMessage: String,
    label: String,
    placeholder: String,
    name: String,
    value: String,
  },
  data() {
    return {
      model: {
        select: this.value
      }
    };
  },
  mounted() {
    this.emitValidation();
  },
  methods: {
    handleValidation(isBlur) {
      this.emitValidation();
      if (isBlur) this.$v.model.select.$touch();
    },
    handleBlur() {
      this.$emit("inputWasChanged", this.isInvalid);
      this.$v.model.select.$touch();
    },
    hasError() {
      return this.$v.model.select.$invalid && this.$v.model.select.$dirty;
    },
    emitValidation() {
      this.$emit("inputWasChanged", this.isInvalid);
    },
    handleInput(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    isInvalid() {
      return this.$v.model.select.$invalid;
    }
  },
  validations: {
    model: {
      select: {
        required: requiredIf(function () {
          return this.isRequired;
        }),
        hasValidValue
      }
    }
  }
};
</script>
